/* ... existing imports ... */
import { QuestProvider } from '@questlabs/react-sdk'

const gretaApiKey = import.meta.env.VITE_GRETA_API_KEY

export const aiAnalysis = {
  async analyzeTradingPerformance(trades, userProfile) {
    try {
      const questProvider = new QuestProvider({ apiKey: gretaApiKey, entityId: userProfile.user_id })
      const analysisPrompt = `
        Analyze the following trading data (P&L is in Rp / Indonesian Rupiah) and provide insights:
        Trades: ${JSON.stringify(trades)}
        Please provide: 1. Win rate analysis 2. Risk-reward patterns 3. Common mistakes 4. Profitable setups 5. Recommendations
      `
      const response = await questProvider.getAIInsight(analysisPrompt)
      return response
    } catch (error) {
      console.error('AI Analysis Error:', error)
      return { error: 'Unable to generate AI analysis', fallback: this.generateBasicAnalysis(trades) }
    }
  },

  generateBasicAnalysis(trades) {
    const totalTrades = trades.length
    const winningTrades = trades.filter(t => t.pnl > 0).length
    const winRate = totalTrades > 0 ? (winningTrades / totalTrades * 100).toFixed(1) : 0
    const totalPnL = trades.reduce((sum, t) => sum + (t.pnl || 0), 0)
    return {
      summary: `Basic Analysis: ${totalTrades} trades, ${winRate}% win rate, Total P&L: Rp ${totalPnL.toLocaleString('id-ID')}`,
      insights: [
        `You have a ${winRate}% win rate from ${totalTrades} trades`,
        totalPnL > 0 ? 'Overall profitable performance' : 'Focus on risk management',
        'Continue tracking trades for more detailed AI analysis'
      ]
    }
  },

  generateBasicWeeklyReport(trades) {
    const totalPnL = trades.reduce((sum, t) => sum + (t.pnl || 0), 0)
    return {
      summary: `Week Summary: ${trades.length} trades, Rp ${totalPnL.toLocaleString('id-ID')} P&L`,
      recommendations: [
        trades.length === 0 ? 'Focus on finding quality setups' : 'Continue current trading approach',
        'Review risk management rules'
      ]
    }
  },
  
  async analyzePsychology(trades, emotions) { return { summary: 'Psychology analysis ready.', insights: ['Maintain discipline.'] } },
  async generateWeeklyReport(trades, start, end) { return this.generateBasicWeeklyReport(trades) }
}